import { OpenNewTabTargetType, } from '@voltmoney/types';
import { BorderRadiusTokens, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, WIDGET, } from '@voltmoney/schema';
import { ACTION } from './types';
import { ROUTE } from '../../routes';
import { PartnerAccountType, } from '../../configs/constants';
import { addCommasToNumber } from '../../configs/utils';
import { partnerApi } from '../../configs/api';
import { getAppHeader } from "../../configs/config";
export const TableDataBuilder = (mockDATA) => {
    let DATA = {
        name: [],
        phoneNumber: [],
        totalPortfolioAmount: [],
        availableCreditAmount: [],
        currentStepName: [],
        lastUpdatedOn: [],
        partnerCode: [],
        customerJourney: [],
    };
    const Title_MAP = {
        name: 'Name',
        panNumber: 'PAN',
        phoneNumber: 'Mobile',
        emailId: 'Email',
        currentStepName: 'Application status',
        createdOn: 'Created on',
    };
    let DATA_STORE = {};
    let TITLE_CONFIG = {
        name: {
            title: 'NAME',
            flex: 1,
            cellMinWidth: 110,
        },
        phoneNumber: {
            title: 'MOBILE',
            flex: 1,
            cellMinWidth: 144,
        },
        currentStepName: {
            title: 'STATUS',
            flex: 1,
            cellMinWidth: 200,
        },
        availableCreditAmount: {
            title: 'AVAILABLE CREDIT AMOUNT',
            flex: 1,
            cellMinWidth: 144,
        },
        lastUpdatedOn: {
            title: 'LAST UPDATED',
            flex: 1,
            cellMinWidth: 144,
        },
        partnerCode: {
            title: 'PARTNER CODE',
            flex: 1,
            cellMaxWidth: 140,
        },
        customerJourney: {
            title: 'ACTION',
            flex: 1,
            cellMaxWidth: 140,
        },
    };
    const TABLE_DATA = [];
    mockDATA.forEach((item, index_i) => {
        let tableObject = {};
        const { date, month, year } = convertISODate(item.applicationLastUpdateTS);
        tableObject = {
            name: item.customerName === null || item.customerName === undefined ? '' : `${item?.customerName}`,
            phoneNumber: item.mobileNumber === null || item.mobileNumber === undefined ? '' : `${item.mobileNumber}`,
            currentStepName: item.applicationStatus === null || item.applicationStatus === undefined ? '' : `${item.applicationStatus}`,
            availableCreditAmount: item.availableLimit === null || item.availableLimit === undefined ? '0' : `${item.availableLimit}`,
            lastUpdatedOn: item.applicationLastUpdateTS === null || item.applicationLastUpdateTS === undefined ? '' : `${date} ${month.slice(0, 3)}, ${year}`,
            customerJourney: item,
            partnerCode: item.voltPartnerCode === null || item.voltPartnerCode === undefined ? '' : `${item.voltPartnerCode}`
        };
        TABLE_DATA.push(tableObject);
        Object.keys(DATA).forEach((fieldName, index_j) => {
            if (fieldName === 'selectMap') {
                DATA[fieldName].push({
                    id: `${fieldName}_${index_i}`,
                    type: WIDGET.RADIO,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`${fieldName}_${index_i}`]: {
                        isChecked: false,
                        size: IconSizeTokens.MD,
                        actionChecked: {
                            type: ACTION.ON_SELECT,
                            routeId: ROUTE.PARTNER_LEAD,
                            payload: { data: item },
                        },
                        actionUnChecked: {
                            type: ACTION.ON_SELECT,
                            routeId: ROUTE.PARTNER_LEAD,
                            payload: { data: item },
                        },
                    },
                };
            }
            else if (fieldName === 'currentStepName') {
                DATA[fieldName].push({
                    id: `${fieldName}_${index_i}`,
                    type: WIDGET.STACK,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`${fieldName}_${index_i}`]: {
                        type: StackType.row,
                        // bgColor: ColorTokens.Grey_Chalk,
                        // justifyContent: StackJustifyContent.flexStart,
                        // alignItems: StackAlignItems.center,
                        borderConfig: {
                            borderRadius: BorderRadiusTokens.BR1,
                        },
                        // padding: {
                        //     vertical: SizeTypeTokens.MD,
                        //     left: SizeTypeTokens.MD,
                        // },
                        widgetItems: [
                            // { id: `icon_${fieldName}_${index_i}`, type: WIDGET.ICON },
                            // { id: `leads_status_space_${fieldName}_${index_i}`, type: WIDGET.SPACE },
                            {
                                id: `statusTitle_${fieldName}_${index_i}`,
                                type: WIDGET.TEXT,
                            },
                        ],
                    },
                    // [`leads_status_space_${fieldName}_${index_i}`]: <SpaceProps>{
                    //     size: SizeTypeTokens.MD
                    // },
                    // [`icon_${fieldName}_${index_i}`]:<IconProps> {
                    //     name: IconTokens.Dot,
                    //     label: IconTokens.Dot,
                    //     size: IconSizeTokens.XXL
                    // },
                    [`statusTitle_${fieldName}_${index_i}`]: {
                        label: `${tableObject[fieldName]}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
            else if (fieldName === 'totalPortfolioAmount' ||
                fieldName === 'availableCreditAmount') {
                DATA[fieldName].push({
                    id: `${fieldName}_${index_i}`,
                    type: WIDGET.STACK,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`${fieldName}_${index_i}`]: {
                        type: StackType.row,
                        justifyContent: StackJustifyContent.flexEnd,
                        alignItems: StackAlignItems.center,
                        widgetItems: [
                            {
                                id: `amountLeads_${fieldName}_${index_i}`,
                                type: WIDGET.TEXT,
                            },
                        ],
                    },
                    [`amountLeads_${fieldName}_${index_i}`]: {
                        label: `₹${tableObject[fieldName]}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
            else if (fieldName === 'createdOn') {
                const { date, month, year } = convertISODate(tableObject[fieldName]);
                DATA[fieldName].push({
                    id: `${fieldName}_${index_i}`,
                    type: WIDGET.TEXT,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`${fieldName}_${index_i}`]: {
                        label: `${date} ${month.slice(0, 3)}, ${year}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
            else if (fieldName === 'lastUpdatedOn') {
                const { date, month, year } = convertISODate(tableObject[fieldName]);
                DATA[fieldName].push({
                    id: `${fieldName}_${index_i}`,
                    type: WIDGET.TEXT,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`${fieldName}_${index_i}`]: {
                        label: `${date} ${month.slice(0, 3)}, ${year}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
            else if (fieldName === 'phoneNumber') {
                DATA[fieldName].push({
                    id: `${fieldName}_${index_i}`,
                    type: WIDGET.TEXT,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`${fieldName}_${index_i}`]: {
                        label: `${tableObject[fieldName]}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
            else if (fieldName === 'customerJourney') {
                DATA[fieldName].push({
                    id: `${fieldName}_${index_i}`,
                    type: WIDGET.STACK,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`${fieldName}_${index_i}`]: {
                        type: StackType.column,
                        alignItems: StackAlignItems.flexStart,
                        justifyContent: StackJustifyContent.center,
                        padding: {
                            top: SizeTypeTokens.XS,
                            left: SizeTypeTokens.XS,
                            bottom: SizeTypeTokens.XS,
                        },
                        widgetItems: [
                            {
                                id: `viewDetail_Stack_${fieldName}_${index_i}`,
                                type: WIDGET.STACK,
                            },
                        ],
                    },
                    [`viewDetail_Stack_${fieldName}_${index_i}`]: {
                        type: StackType.row,
                        widgetItems: [
                            { id: `viewDetails_${fieldName}_${index_i}`, type: WIDGET.TEXT }
                        ],
                        padding: {
                            top: SizeTypeTokens.SM,
                            bottom: SizeTypeTokens.SM
                        },
                        action: {
                            routeId: ROUTE.PLATFORM_LEADS,
                            type: ACTION.VIEW_DETAILS,
                            payload: {
                                user: tableObject[fieldName],
                            },
                        },
                    },
                    [`viewDetails_${fieldName}_${index_i}`]: {
                        label: `View details \u276F`,
                        fontSize: FontSizeTokens.SM,
                        fontWeight: '600',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Primary_100,
                        lineHeight: 18,
                    },
                };
            }
            else {
                DATA[fieldName].push({
                    id: `${fieldName}_${index_i}`,
                    type: WIDGET.TEXT,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`${fieldName}_${index_i}`]: {
                        label: `${tableObject[fieldName]}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
        });
    });
    console.log('DATA: ', DATA);
    return { Title_MAP, DATA, DATA_STORE, TITLE_CONFIG, TABLE_DATA };
};
export const ActiveCustomerTableBuilder = (mockDATA) => {
    let DATA = {
        // selectMap: [],
        name: [],
        phoneNumber: [],
        totalValueOfAssetsPledged: [],
        approvedCreditAmount: [],
        principalOutStandingAmount: [],
        overUtilizationAmount: [],
        availableCreditAmount: [],
        customerJourney: []
    };
    const Title_MAP = {
        // selectMap: '',
        name: 'Name',
        totalPortfolioAmount: 'Portfolio Amount',
        approvedCreditAmount: 'Sanction Limit',
        // needs to be make a extra field for this
        limitIncreaseAvailable: 'Limit Increase Available',
        // should be default zero
        principalOutStandingAmount: 'Withdrawn amount',
        availableCreditAmount: 'Available amount for disbursement',
        createdOn: 'Contract Start Date',
        expiresOn: 'Contract End Date',
    };
    const TITLE_CONFIG = {
        name: {
            title: 'NAME',
            flex: 2,
            cellMinWidth: 144,
        },
        // needs to be make a extra field for this
        phoneNumber: {
            title: 'MOBILE',
            flex: 2,
            cellMinWidth: 112,
        },
        approvedCreditAmount: {
            title: 'TOTAL CREDIT LIMIT',
            flex: 2,
            cellMinWidth: 80,
        },
        availableCreditAmount: {
            title: 'AVAILABLE CREDIT LIMIT',
            flex: 2,
            cellMinWidth: 80,
        },
        principalOutStandingAmount: {
            title: 'OUTSTANDING AMOUNT',
            flex: 2,
            cellMinWidth: 80,
        },
        customerJourney: {
            title: 'ACTION',
            flex: 2,
            cellMinWidth: 112,
        },
    };
    let DATA_STORE = {};
    console.log('*** mockDATA ***: ', mockDATA);
    const TABLE_DATA = [];
    mockDATA.forEach((item, index_i) => {
        let tableObject = {};
        tableObject = {
            name: item.name === null || item.name === undefined ? '' : `${item.name}`,
            phoneNumber: item.mobileNumber === null || item.mobileNumber === undefined ? '' : `${item.mobileNumber}`,
            approvedCreditAmount: item?.creditDetails?.totalCreditAmount === null || item?.creditDetails?.totalCreditAmount === undefined ? '0' : `${item?.creditDetails?.totalCreditAmount}`,
            availableCreditAmount: item?.creditDetails?.availableCreditAmount === null || item?.creditDetails?.availableCreditAmount === undefined ? '0' : `${item?.creditDetails?.availableCreditAmount}`,
            principalOutStandingAmount: item?.creditDetails?.principalOutStandingAmount === null || item?.creditDetails?.principalOutStandingAmount === undefined ? '0' : `${item?.creditDetails?.principalOutStandingAmount}`,
            applicationLastUpdateTS: item?.applicationLastUpdateTS === null || item?.applicationLastUpdateTS === undefined ? '' : item.applicationLastUpdateTS,
            pledgedPortfolioAmount: item?.creditDetails?.pledgedPortfolioAmount === null || item?.creditDetails?.pledgedPortfolioAmount === undefined ? '' : item?.creditDetails?.pledgedPortfolioAmount,
            createdOn: item?.createdOn === null || item?.createdOn === undefined ? '' : item.createdOn,
            customerJourney: item,
        };
        TABLE_DATA.push(tableObject);
        Object.keys(DATA).forEach((fieldName, index_j) => {
            if (fieldName === 'selectMap') {
                DATA[fieldName].push({
                    id: `AC_${fieldName}_${index_i}`,
                    type: WIDGET.RADIO,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`AC_${fieldName}_${index_i}`]: {
                        isChecked: false,
                        size: IconSizeTokens.MD,
                        actionChecked: {
                            type: ACTION.ON_SELECT_AC,
                            routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                            payload: { data: item },
                        },
                        actionUnChecked: {
                            type: ACTION.ON_SELECT_AC,
                            routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                            payload: { data: item },
                        },
                    },
                };
            }
            else if (fieldName === 'totalValueOfAssetsPledged' ||
                fieldName === 'approvedCreditAmount' ||
                fieldName === 'principalOutStandingAmount' ||
                fieldName === 'overUtilizationAmount' ||
                fieldName === 'availableCreditAmount') {
                DATA[fieldName].push({
                    id: `AC_${fieldName}_${index_i}`,
                    type: WIDGET.STACK,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`AC_${fieldName}_${index_i}`]: {
                        type: StackType.row,
                        justifyContent: StackJustifyContent.flexEnd,
                        alignItems: StackAlignItems.center,
                        widgetItems: [
                            {
                                id: `AC_AmountStack_${fieldName}_${index_i}`,
                                type: WIDGET.TEXT,
                            },
                        ],
                    },
                    [`AC_AmountStack_${fieldName}_${index_i}`]: {
                        label: `₹${addCommasToNumber(tableObject[fieldName])}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
            else if (fieldName === 'createdOn') {
                const { date, month, year } = convertISODate(tableObject[fieldName]);
                DATA[fieldName].push({
                    id: `AC_${fieldName}_${index_i}`,
                    type: WIDGET.TEXT,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`AC_${fieldName}_${index_i}`]: {
                        label: `${date} ${month.slice(0, 3)}, ${year}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
            else if (fieldName === 'renewalDate') {
                const { date, month, year } = convertISODate(tableObject[fieldName]);
                DATA[fieldName].push({
                    id: `AC_${fieldName}_${index_i}`,
                    type: WIDGET.TEXT,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`AC_${fieldName}_${index_i}`]: {
                        label: `${date} ${month.slice(0, 3)}, ${year}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
            else if (fieldName === 'phoneNumber') {
                DATA[fieldName].push({
                    id: `AC_${fieldName}_${index_i}`,
                    type: WIDGET.TEXT,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`AC_${fieldName}_${index_i}`]: {
                        label: `${tableObject[fieldName]}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
            else if (fieldName === 'customerJourney') {
                DATA[fieldName].push({
                    id: `AC_${fieldName}_${index_i}`,
                    type: WIDGET.STACK,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`AC_${fieldName}_${index_i}`]: {
                        type: StackType.column,
                        alignItems: StackAlignItems.flexStart,
                        justifyContent: StackJustifyContent.center,
                        padding: {
                            top: SizeTypeTokens.XS,
                            left: SizeTypeTokens.XS,
                            bottom: SizeTypeTokens.XS,
                        },
                        widgetItems: [
                            {
                                id: `AC_viewDetail_Stack_${fieldName}_${index_i}`,
                                type: WIDGET.STACK,
                            },
                        ],
                    },
                    [`AC_viewDetail_Stack_${fieldName}_${index_i}`]: {
                        type: StackType.row,
                        padding: {
                            top: SizeTypeTokens.SM,
                            bottom: SizeTypeTokens.SM
                        },
                        widgetItems: [
                            { id: `AC_viewDetails_${fieldName}_${index_i}`, type: WIDGET.TEXT }
                        ],
                        action: {
                            routeId: ROUTE.PLATFORM_ACTIVE_CUSTOMERS,
                            type: ACTION.VIEW_DETAILS,
                            payload: {
                                user: tableObject[fieldName],
                            },
                        },
                    },
                    [`AC_viewDetails_${fieldName}_${index_i}`]: {
                        label: `View details \u276F`,
                        fontSize: FontSizeTokens.SM,
                        fontWeight: '600',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Primary_100,
                        lineHeight: 18,
                    },
                };
            }
            else {
                DATA[fieldName].push({
                    id: `AC_${fieldName}_${index_i}`,
                    type: WIDGET.TEXT,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`AC_${fieldName}_${index_i}`]: {
                        label: `${tableObject[fieldName]}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
        });
    });
    return { Title_MAP, DATA, DATA_STORE, TITLE_CONFIG, TABLE_DATA };
};
export const ReferredPartnerTableBuilder = (mockDATA) => {
    const DATA = {
        partnerName: [],
        partnerMobileNumber: [],
        partnerActivationStatus: [],
        empanelmentDate: [],
        partnerCode: [],
    };
    const Title_MAP = {
        partnerName: 'Name',
        partnerMobileNumber: 'Portfolio Amount',
        partnerActivationStatus: 'Status',
        empanelmentDate: 'Date of empanelment',
        partnerCode: 'Partner Code'
    };
    const TITLE_CONFIG = {
        partnerName: {
            title: 'MFD NAME',
            flex: 1,
            cellMinWidth: 144,
            cellMaxWidth: 200,
        },
        partnerMobileNumber: {
            title: 'MOBILE',
            flex: 1,
            cellMinWidth: 112,
            cellMaxWidth: 200,
        },
        partnerActivationStatus: {
            title: 'STATUS',
            flex: 1,
            cellMinWidth: 144,
            cellMaxWidth: 200,
        },
        empanelmentDate: {
            title: 'DATE OF EMPANELMENT',
            flex: 1,
            cellMinWidth: 144,
        },
        partnerCode: {
            title: 'PARTNER CODE',
            flex: 1,
            cellMinWidth: 144,
        }
    };
    let DATA_STORE = {};
    const TABLE_DATA = [];
    mockDATA.forEach((item, index_i) => {
        let tableObject = {};
        const { date, month, year } = convertISODate(item.dateOfEmpanelment);
        tableObject = {
            partnerName: item.name === null || item.name === undefined ? '' : `${item.name}`,
            partnerMobileNumber: item.phoneNumber === null || item.phoneNumber === undefined ? '' : `${item.phoneNumber}`,
            partnerActivationStatus: item.accountState === null || item.accountState === undefined ? '' : `${item.accountState}`,
            empanelmentDate: item.dateOfEmpanelment === null || item.dateOfEmpanelment === undefined ? '' : `${date} ${month.slice(0, 3)}, ${year}`,
            partnerCode: item.voltPartnerCode === null || item.voltPartnerCode === undefined ? '' : `${item.voltPartnerCode}`
        };
        TABLE_DATA.push(tableObject);
        Object.keys(DATA).forEach((fieldName, index_j) => {
            if (fieldName === 'partnerMobileNumber') {
                DATA[fieldName].push({
                    id: `RP_${fieldName}_${index_i}`,
                    type: WIDGET.TEXT,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`RP_${fieldName}_${index_i}`]: {
                        label: `${tableObject[fieldName]}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
            else if (fieldName === 'empanelmentDate') {
                DATA[fieldName].push({
                    id: `RP_${fieldName}_${index_i}`,
                    type: WIDGET.TEXT,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`RP_${fieldName}_${index_i}`]: {
                        label: `${tableObject[fieldName]}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
            else {
                DATA[fieldName].push({
                    id: `RP_${fieldName}_${index_i}`,
                    type: WIDGET.TEXT,
                });
                DATA_STORE = {
                    ...DATA_STORE,
                    [`RP_${fieldName}_${index_i}`]: {
                        label: `${tableObject[fieldName]}`,
                        fontSize: FontSizeTokens.XS,
                        fontWeight: '400',
                        fontFamily: FontFamilyTokens.Inter,
                        color: ColorTokens.Grey_Night,
                        lineHeight: 18,
                    },
                };
            }
        });
    });
    return { Title_MAP, DATA, DATA_STORE, TITLE_CONFIG, TABLE_DATA };
};
/**
 @description function to search string value in object property
 **/
export const searchObject = (obj, searchString) => {
    const results = [];
    obj &&
        Object.keys(obj).forEach((key, index) => {
            const value = obj[key];
            // Check if the value is an object and recursively search it
            if (typeof value === 'object') {
                results.push(...searchObject(value, searchString));
            }
            // If the value is a string and contains the search string, add it to the results array
            if (checkIfFieldIsValid(key) &&
                typeof value === 'string' &&
                value.toLowerCase().includes(searchString.toLowerCase())) {
                results.push(value);
            }
        });
    return results;
};
export const convertISODate = (timeString) => {
    // timeString = "2023-02-28T10:30:52.119Z";
    const dateObj = new Date(timeString);
    const date = dateObj.toLocaleDateString('en-US', { day: 'numeric' });
    const month = dateObj.toLocaleDateString('en-US', { month: 'long' });
    const year = dateObj.toLocaleDateString('en-US', { year: 'numeric' });
    return { date, month, year };
};
export const sortPartnerObjectByProperty = (objects, propertyName, asc) => {
    return objects.sort(function (a, b) {
        if (propertyName === 'createdOn' ||
            propertyName === 'applicationState' ||
            propertyName === 'lastUpdatedOn') {
            if (a?.applicationLastUpdateTS <
                b?.applicationLastUpdateTS) {
                return asc ? -1 : 1;
            }
            else {
                return asc ? 1 : -1;
            }
        }
        else if (propertyName === 'phoneNumber' || propertyName === 'name') {
            if (a?.name <
                b?.name) {
                return asc ? -1 : 1;
            }
            else {
                return asc ? 1 : -1;
            }
        }
        return 0;
    });
};
export const sortReferredPartnerObjectByProperty = (objects, propertyName, asc) => {
    return objects.sort(function (a, b) {
        if (propertyName === 'partnerName' ||
            propertyName === 'partnerMobileNumber' ||
            propertyName === 'partnerActivationStatus') {
            if (a?.partnerName < b?.partnerName) {
                return asc ? -1 : 1;
            }
            else {
                return asc ? 1 : -1;
            }
        }
    });
};
// export const sortActiveCustomerObjectsByProperty = (
//     objects: PartnerLeadsType[],
//     propertyName,
//     asc: boolean,
// ) => {
//     return objects.sort(function (a, b) {
//         if (
//             propertyName === 'totalValueOfAssetsPledged' ||
//             propertyName === 'approvedCreditAmount' ||
//             propertyName === 'principalOutStandingAmount' ||
//             propertyName === 'overUtilizationAmount' ||
//             propertyName === 'renewalDate'
//         ) {
//             if (
//                 a?.credit[propertyName] <
//                 b?.credit[propertyName]
//             ) {
//                 return asc ? -1 : 1
//             } else {
//                 return asc ? 1 : -1
//             }
//         } else if (
//             propertyName === 'phoneNumber' ||
//             propertyName === 'name'
//         ) {
//             if (
//                 a?.borrowerAccountProfile[propertyName] <
//                 b?.borrowerAccountProfile[propertyName]
//             ) {
//                 return asc ? -1 : 1
//             } else {
//                 return asc ? 1 : -1
//             }
//         }
//         return 0;
//     });
// }
// export const rebuildReferredPartnerTable = async (
//     StandardUtilities,
//     ReferredPartnerData: ReferredPartnerDataType[],
//     action: Action<any>,
// ) => {
//     await StandardUtilities.setDatastore(
//         ROUTE.PARTNER_REFERRED_PARTNER,
//         'referredPartnerTable',
//         <TableProps>{
//             widgetData: {
//                 ...ReferredPartnerTableBuilder(ReferredPartnerData).DATA,
//             },
//             data: ReferredPartnerData,
//         },
//     )
//     const TITLE_CONFIG = ReferredPartnerTableBuilder(ReferredPartnerData).DATA
//     const TABLE_DATA =
//         ReferredPartnerTableBuilder(ReferredPartnerData).TABLE_DATA
//     if (ReferredPartnerData && ReferredPartnerData.length > 0) {
//         ReferredPartnerData.map((item, index_i) => {
//             TITLE_CONFIG &&
//             Object.keys(TITLE_CONFIG).forEach((fieldName, index_j) => {
//                 if (fieldName === 'partnerMobileNumber') {
//                     StandardUtilities.setDatastore(
//                         ROUTE.PARTNER_REFERRED_PARTNER,
//                         `RP_${fieldName}_${index_i}`,
//                         <TypographyProps>{
//                             label: `${TABLE_DATA[index_i][fieldName]}`.slice(
//                                 3,
//                             ),
//                         },
//                     )
//                 } else if (fieldName === 'empanelmentDate') {
//                     const {date, month, year} = convertISODate(
//                         TABLE_DATA[index_i][fieldName],
//                     )
//                     StandardUtilities.setDatastore(
//                         ROUTE.PARTNER_LEAD,
//                         `RP_${fieldName}_${index_i}`,
//                         <TypographyProps>{
//                             label: `${date} ${month.slice(0, 3)}, ${year}`,
//                         },
//                     )
//                 } else {
//                     StandardUtilities.setDatastore(
//                         ROUTE.PARTNER_REFERRED_PARTNER,
//                         `RP_${fieldName}_${index_i}`,
//                         <TypographyProps>{
//                             label: `${TABLE_DATA[index_i][fieldName]}`,
//                         },
//                     )
//                 }
//             })
//         })
//     }
//     // await StandardUtilities.setDatastore(
//     //     ROUTE.PARTNER_REFERRED_PARTNER,
//     //     'renderWidgetGroup',
//     //     <RenderWidgetGroupProps>{
//     //         extraProps: { ReferredPartnerData },
//     //     },
//     // )
// }
export const checkIfFieldIsValid = (key, titleConfig) => {
    if (key === 'name' || key === 'customerName' ||
        key === 'phoneNumber' || key === 'mobileNumber' ||
        key === 'partnerName' ||
        key === 'accountHolderPhoneNumber' || key === 'voltPartnerCode') {
        return true;
    }
    return false;
};
export const sideBarNavigate = async (standardUtilities, action) => {
    const routeName = action.payload.routeId;
    const routeParam = action?.payload?.params;
    const routeConfig = routeName === ROUTE.PLATFORM_DASHBOARD ?
        ROUTE_PLATFORM.DASHBOARD :
        routeName === ROUTE.PLATFORM_LEADS ?
            ROUTE_PLATFORM.LEADS
            : routeName === ROUTE.PLATFORM_ACTIVE_CUSTOMERS ?
                ROUTE_PLATFORM.ACTIVE_CUSTOMER
                : routeName === ROUTE.PLATFORM_LINKED_PARTNERS ?
                    ROUTE_PLATFORM.LINKED_PARTNER
                    : ROUTE_PLATFORM.DASHBOARD;
    routeParam === undefined ? standardUtilities.openNewTab(`/platform/${routeConfig}`, OpenNewTabTargetType.self) :
        standardUtilities.openNewTab(`/platform/${routeConfig}?${routeParam}`, OpenNewTabTargetType.self);
};
export const navigateByUrl = async (routeName, openNewTab) => {
    const routeConfig = routeName === ROUTE.PLATFORM_SIGN_UP ?
        ROUTE.PLATFORM_SIGN_UP :
        routeName === ROUTE.PLATFORM_DASHBOARD ?
            ROUTE_PLATFORM.DASHBOARD :
            routeName === ROUTE.PLATFORM_LEADS ?
                ROUTE_PLATFORM.LEADS
                : routeName === ROUTE.PLATFORM_ACTIVE_CUSTOMERS ?
                    ROUTE_PLATFORM.ACTIVE_CUSTOMER
                    : routeName === ROUTE.PLATFORM_LINKED_PARTNERS ?
                        ROUTE_PLATFORM.LINKED_PARTNER
                        : ROUTE_PLATFORM.DASHBOARD;
    await openNewTab(`/platform/${routeConfig}`, OpenNewTabTargetType.self);
};
export const ROUTE_PLATFORM = {
    SIGNUP: 'login',
    DASHBOARD: 'dashboard',
    PARTNER: 'partners',
    FAQ: 'faq',
    LEADS: 'leads',
    ACTIVE_CUSTOMER: 'customers',
    LINKED_PARTNER: 'referredPartners',
    PLATFORM: 'platform',
};
const postMessageChildToParent = (message, targetOrigin = '*') => {
    window.parent.postMessage(message, targetOrigin);
};
const postMessageParentToChild = (message, targetOrigin = '*') => {
    const iframe = document.querySelector('iframe');
    if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(message, targetOrigin);
    }
};
const postMessageObserver = (callBack) => {
    window.addEventListener('message', callBack);
};
export const WebViewUtils = {
    postMessageChildToParent,
    postMessageParentToChild,
    postMessageObserver,
};
export const onTrackCustomer = async (userId, network, asyncStorage) => {
    const header = await getAppHeader();
    header["X-AppPlatform"] = 'VOLT_WEB_APP';
    const response = await network.post(`${partnerApi.generateLink}${userId}`, {}, {
        headers: header
    });
    setTimeout(() => WebViewUtils.postMessageParentToChild(response.data), 0);
};
export const LeadMobileCardBuilder = (mockDATA) => {
    let DATA_STORE = {};
    const WIDGET_STORE = [];
    // we want to create the card component for each item
    mockDATA.forEach((item, index) => {
        let partnerDetailCardObject = {};
        partnerDetailCardObject = {
            name: item.customerName === null || item.customerName === undefined ? '' : `${item?.customerName}`,
            phoneNumber: item.customerName === null || item.customerName === undefined ? '' : `${item.mobileNumber}`,
            currentStepName: item.applicationStatus === null || item.applicationStatus === undefined ? '' : `${item.applicationStatus}`,
            availableCreditAmount: item.availableLimit === null || item.availableLimit === undefined ? '0' : `${item.availableLimit}`,
            lastUpdatedOn: item.applicationLastUpdateTS === null || item.applicationLastUpdateTS === undefined ? '' : `30th June`,
            userData: item
        };
        // for each object we need to create a partner detail card
        WIDGET_STORE.push({ id: `leadsMobDetailsCard_${index}`, type: WIDGET.PARTNER_DETAILS_CARD });
        WIDGET_STORE.push({ id: `leadsMobDetailsCardSpace_${index}`, type: WIDGET.SPACE });
        DATA_STORE = {
            ...DATA_STORE,
            [`leadsMobDetailsCard_${index}`]: {
                title: `${partnerDetailCardObject['name'] ? partnerDetailCardObject['name'] : partnerDetailCardObject['phoneNumber']}`,
                detailItems: [
                    { title: 'Status', value: `${partnerDetailCardObject['currentStepName']}` },
                    {
                        title: 'Available credit limit',
                        value: partnerDetailCardObject['availableCreditAmount'] !== 'Pending' ? `₹${addCommasToNumber(partnerDetailCardObject['availableCreditAmount'])}` : partnerDetailCardObject['availableCreditAmount']
                    },
                ],
                actionItems: [
                    {
                        title: 'View detail',
                        action: {
                            routeId: ROUTE.PLATFORM_LEADS,
                            type: ACTION.VIEW_DETAILS,
                            payload: {
                                user: partnerDetailCardObject['userData']
                            }
                        }
                    },
                ]
            },
            [`leadsMobDetailsCardSpace_${index}`]: {
                size: SizeTypeTokens.XL
            }
        };
    });
    return { WIDGET_STORE, DATA_STORE };
};
export const ActiveCustomerCardBuilder = (mockDATA) => {
    console.log("Active customer card builder: ", mockDATA);
    let DATA_STORE = {};
    const WIDGET_STORE = [];
    // we want to create the card component for each item
    mockDATA.forEach((item, index) => {
        let partnerDetailCardObject = {};
        partnerDetailCardObject = {
            name: item.name === null || item.name === undefined ? '' : `${item.name}`,
            phoneNumber: item.mobileNumber === null || item.mobileNumber === undefined ? '' : `${item.mobileNumber}`,
            approvedCreditAmount: item?.creditDetails?.totalCreditAmount === null || item?.creditDetails?.totalCreditAmount === undefined ? '0' : `${item?.creditDetails?.totalCreditAmount}`,
            availableCreditAmount: item?.creditDetails?.availableCreditAmount === null || item?.creditDetails?.availableCreditAmount === undefined ? '0' : `${item?.creditDetails?.availableCreditAmount}`,
            principalOutStandingAmount: item?.creditDetails?.principalOutStandingAmount === null || item?.creditDetails?.principalOutStandingAmount === undefined ? '0' : `${item?.creditDetails?.principalOutStandingAmount}`,
            userData: item
        };
        // for each object we need to create a partner detail card
        WIDGET_STORE.push({ id: `activeCustomerMobDetailsCard_${index}`, type: WIDGET.PARTNER_DETAILS_CARD });
        WIDGET_STORE.push({ id: `activeCustomerMobDetailsCardSpace_${index}`, type: WIDGET.SPACE });
        DATA_STORE = {
            ...DATA_STORE,
            [`activeCustomerMobDetailsCard_${index}`]: {
                title: `${partnerDetailCardObject['name'] ? partnerDetailCardObject['name'] : partnerDetailCardObject['phoneNumber']}`,
                detailItems: [
                    {
                        title: 'Available limit',
                        value: `₹${partnerDetailCardObject['availableCreditAmount']}`,
                    },
                    {
                        title: 'Outstanding amount',
                        value: partnerDetailCardObject['principalOutStandingAmount'] === undefined ? '₹0' : `₹${addCommasToNumber(partnerDetailCardObject['principalOutStandingAmount'])}`
                    },
                ],
                actionItems: [
                    {
                        title: 'View detail',
                        action: {
                            routeId: ROUTE.PLATFORM_ACTIVE_CUSTOMERS,
                            type: ACTION.VIEW_DETAILS,
                            payload: {
                                user: partnerDetailCardObject['userData']
                            }
                        }
                    },
                ]
            },
            [`activeCustomerMobDetailsCardSpace_${index}`]: {
                size: SizeTypeTokens.XL
            }
        };
    });
    return { WIDGET_STORE, DATA_STORE };
};
// export const rebuildLeadMobileCardBuilder = async (
//     StandardUtilities,
//     mockDATA: PartnerLeadsType[],
//     partnerAccountType?: PartnerAccountType
// ) => {
//
//     // rebuild the 'leadsMobCardStack'
//     await StandardUtilities.setDatastore(
//         ROUTE.PARTNER_LEAD,
//         'leadsMobCardStack',
//         <StackProps>{
//             widgetItems: [
//                 ...LeadMobileCardBuilder(mockDATA).WIDGET_STORE,
//             ]
//         }
//     );
//
//     //we want to create the card component for each item
//     for (const item of mockDATA) {
//         const index = mockDATA.indexOf(item);
//         let partnerDetailCardObject = {};
//         partnerDetailCardObject = {
//             name: item?.borrowerAccountProfile.name ? item?.borrowerAccountProfile.name : '',
//             phoneNumber: item?.borrowerAccountProfile?.phoneNumber,
//             //status
//             currentStepName: item.currentStepName ? item.currentStepName : '',
//             //Available credit limit
//             approvedCreditAmount: item?.assetDetails?.approvedCreditAmount ? item.assetDetails.approvedCreditAmount : 'Pending',
//             userData: item
//         }
//         await StandardUtilities.setDatastore(
//             ROUTE.PARTNER_LEAD,
//             `leadsMobDetailsCard_${index}`,
//             <PartnerDetailsCardProps>{
//                 title: `${partnerDetailCardObject['name'] ? partnerDetailCardObject['name'] : partnerDetailCardObject['phoneNumber']}`,
//                 detailItems: [
//                     {title: 'Status', value: `${partnerDetailCardObject['currentStepName']}`},
//                     {
//                         title: 'Available credit limit',
//                         value: partnerDetailCardObject['availableCreditAmount'] !== 'Pending' ? `₹${addCommasToNumber(partnerDetailCardObject['availableCreditAmount'])}` : partnerDetailCardObject['availableCreditAmount']
//                     },
//                 ],
//                 actionItems: [
//                     {
//                         title: 'View detail',
//                         action: {
//                             routeId: ROUTE.PARTNER_LEAD,
//                             type: ACTION.VIEW_DETAILS,
//                             payload: {
//                                 user: partnerDetailCardObject['userData']
//                             }
//                         }
//                     },
//                     {
//                         title: 'Share link',
//                         action: {
//                             routeId: ROUTE.PARTNER_LEAD,
//                             type: ACTION.SHARE_LINK,
//                             payload: {
//                                 user: partnerDetailCardObject['userData']
//                             }
//                         }
//                     },
//                     (
//                         partnerAccountType &&
//                         partnerAccountType === PartnerAccountType.INDIVIDUAL
//                     ) && {
//                         title: 'MFD led journey',
//                         action: {
//                             routeId: ROUTE.PARTNER_LEAD,
//                             type: ACTION.ON_TRACK_CUSTOMER_JOURNEY,
//                             payload: {
//                                 value: partnerDetailCardObject['userData']
//                             }
//                         }
//                     },
//                 ]
//             }
//         )
//         await StandardUtilities.setDatastore(
//             ROUTE.PARTNER_LEAD,
//             `leadsMobDetailsCardSpace_${index}`,
//             <SpaceProps>{
//                 size: SizeTypeTokens.XL
//             }
//         )
//     }
// }
export const rebuildActiveCustomerMobileCardBuilder = async (StandardUtilities, mockDATA, partnerAccountType) => {
    // rebuild the 'leadsMobCardStack'
    await StandardUtilities.setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, 'activeCustomerMobCardStack', {
        widgetItems: ActiveCustomerCardBuilder(mockDATA).WIDGET_STORE,
    });
    //we want to create the card component for each item
    for (const item of mockDATA) {
        const index = mockDATA.indexOf(item);
        let partnerDetailCardObject = {};
        partnerDetailCardObject = {
            name: item.name === null || item.name === undefined ? '' : `${item.name}`,
            phoneNumber: item.mobileNumber === null || item.mobileNumber === undefined ? '' : `${item.mobileNumber}`,
            approvedCreditAmount: item?.creditDetails?.totalCreditAmount === null || item?.creditDetails?.totalCreditAmount === undefined ? '0' : `${item?.creditDetails?.totalCreditAmount}`,
            availableCreditAmount: item?.creditDetails?.availableCreditAmount === null || item?.creditDetails?.availableCreditAmount === undefined ? '0' : `${item?.creditDetails?.availableCreditAmount}`,
            principalOutStandingAmount: item?.creditDetails?.principalOutStandingAmount === null || item?.creditDetails?.principalOutStandingAmount === undefined ? '0' : `${item?.creditDetails?.principalOutStandingAmount}`,
            userData: item
        };
        await StandardUtilities.setDatastore(ROUTE.PLATFORM_ACTIVE_CUSTOMERS, `activeCustomerMobDetailsCard_${index}`, {
            title: `${partnerDetailCardObject['name'] ? partnerDetailCardObject['name'] : partnerDetailCardObject['phoneNumber']}`,
            detailItems: [
                {
                    title: 'Available limit',
                    value: `₹${addCommasToNumber(partnerDetailCardObject['availableCreditAmount'])}`
                },
                {
                    title: 'Outstanding amount',
                    value: `₹${addCommasToNumber(partnerDetailCardObject['principalOutStandingAmount'])}`
                },
            ],
            actionItems: [
                (partnerAccountType && partnerAccountType === PartnerAccountType.INDIVIDUAL) ? {
                    title: 'View as client',
                    action: {
                        routeId: ROUTE.PLATFORM_ACTIVE_CUSTOMERS,
                        type: ACTION.ON_TRACK_CUSTOMER_JOURNEY,
                        payload: {
                            value: partnerDetailCardObject['userData']
                        }
                    }
                } : {},
                {
                    title: 'View detail',
                    action: {
                        routeId: ROUTE.PLATFORM_ACTIVE_CUSTOMERS,
                        type: ACTION.VIEW_DETAILS,
                        payload: {
                            user: partnerDetailCardObject['userData']
                        }
                    }
                },
            ]
        });
        await StandardUtilities.setDatastore(ROUTE.PARTNER_LEAD, `activeCustomerMobDetailsCardSpace_${index}`, {
            size: SizeTypeTokens.XL
        });
    }
};
export const ReferredPartnerMobileCardBuilder = (mockDATA) => {
    let DATA_STORE = {};
    const WIDGET_STORE = [];
    // we want to create the card component for each item
    mockDATA.forEach((item, index) => {
        let partnerDetailCardObject = {};
        const { date, month, year } = convertISODate(item.dateOfEmpanelment);
        partnerDetailCardObject = {
            partnerName: item.name === null || item.name === undefined ? '' : `${item.name}`,
            partnerMobileNumber: item.phoneNumber === null || item.phoneNumber === undefined ? '' : `${item.phoneNumber}`,
            partnerActivationStatus: item.accountState === null || item.accountState === undefined ? '' : `${item.accountState}`,
            empanelmentDate: item.dateOfEmpanelment === null || item.dateOfEmpanelment === undefined ? '' : `${date} ${month.slice(0, 3)} ${year}`,
        };
        // for each object we need to create a partner detail card
        WIDGET_STORE.push({ id: `ReferredPartnerMobDetailsCard_${index}`, type: WIDGET.PARTNER_DETAILS_CARD });
        WIDGET_STORE.push({ id: `ReferredPartnerMobDetailsCardSpace_${index}`, type: WIDGET.SPACE });
        DATA_STORE = {
            ...DATA_STORE,
            [`ReferredPartnerMobDetailsCard_${index}`]: {
                title: `${partnerDetailCardObject['partnerName']}`,
                detailItems: [
                    { title: 'Contact no', value: `${partnerDetailCardObject['partnerMobileNumber']}` },
                    { title: 'Status', value: `${partnerDetailCardObject['partnerActivationStatus']}` },
                    { title: 'Date of empanelment', value: `${partnerDetailCardObject['empanelmentDate']}` },
                ],
                actionItems: []
            },
            [`ReferredPartnerMobDetailsCardSpace_${index}`]: {
                size: SizeTypeTokens.XL
            }
        };
    });
    return { WIDGET_STORE, DATA_STORE };
};
export const rebuildReferredPartnerMobileCardBuilder = async (StandardUtilities, mockDATA) => {
    await StandardUtilities.setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, 'referredPartnerCardStack', {
        widgetItems: ReferredPartnerMobileCardBuilder(mockDATA).WIDGET_STORE,
    });
    for (const item of mockDATA) {
        const index = mockDATA.indexOf(item);
        let partnerDetailCardObject = {};
        const { date, month, year } = convertISODate(item.dateOfEmpanelment);
        partnerDetailCardObject = {
            partnerName: item.name === null || item.name === undefined ? '' : `${item.name}`,
            partnerMobileNumber: item.phoneNumber === null || item.phoneNumber === undefined ? '' : `${item.phoneNumber}`,
            partnerActivationStatus: item.accountState === null || item.accountState === undefined ? '' : `${item.accountState}`,
            empanelmentDate: item.dateOfEmpanelment === null || item.dateOfEmpanelment === undefined ? '' : `${date} ${month}, ${year}`,
        };
        await StandardUtilities.setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, `ReferredPartnerMobDetailsCard_${index}`, {
            title: `${partnerDetailCardObject['partnerName'] ? partnerDetailCardObject['partnerName'] : partnerDetailCardObject['phoneNumber']}`,
            detailItems: [
                { title: 'Contact no', value: `${partnerDetailCardObject['partnerMobileNumber']}` },
                { title: 'Status', value: `${partnerDetailCardObject['partnerActivationStatus']}` },
                { title: 'Date of empanelment', value: `${partnerDetailCardObject['empanelmentDate']}` },
            ],
            actionItems: []
        });
        await StandardUtilities.setDatastore(ROUTE.PLATFORM_LINKED_PARTNERS, `ReferredPartnerMobDetailsCardSpace_${index}`, {
            size: SizeTypeTokens.XL
        });
    }
};
export const getEpochTime = (epochTimestamp) => {
    console.warn("epoachTIme", epochTimestamp);
    const date = new Date(epochTimestamp); // Convert to milliseconds
    const formattedTime = date.toLocaleString('en-IN', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
    });
    return formattedTime;
};
export const rebuildLeadsTable = async (StandardUtilities, PartnerLeadsData, action) => {
    await StandardUtilities.setDatastore(action.routeId, 'leadTable', {
        widgetData: {
            ...TableDataBuilder(PartnerLeadsData).DATA,
        },
        data: PartnerLeadsData,
    });
    const TITLE_CONFIG = TableDataBuilder(PartnerLeadsData).DATA;
    const TABLE_DATA = TableDataBuilder(PartnerLeadsData).TABLE_DATA;
    if (PartnerLeadsData && PartnerLeadsData.length > 0) {
        PartnerLeadsData.map((item, index_i) => {
            TITLE_CONFIG &&
                Object.keys(TITLE_CONFIG).forEach((fieldName, index_j) => {
                    console.log('fieldName: ', fieldName);
                    if (fieldName === 'currentStepName') {
                        StandardUtilities.setDatastore(ROUTE.PLATFORM_LEADS, `${fieldName}_${index_i}`, {
                            widgetItems: [
                                {
                                    id: `statusTitle_${fieldName}_${index_i}`,
                                    type: WIDGET.TEXT,
                                },
                            ],
                        });
                        StandardUtilities.setDatastore(ROUTE.PLATFORM_LEADS, `statusTitle_${fieldName}_${index_i}`, {
                            label: `${TABLE_DATA[index_i][fieldName]}`,
                        });
                    }
                    else if (fieldName === 'totalPortfolioAmount' ||
                        fieldName === 'availableCreditAmount') {
                        StandardUtilities.setDatastore(ROUTE.PLATFORM_LEADS, `${fieldName}_${index_i}`, {
                            widgetItems: [
                                {
                                    id: `amountLeads_${fieldName}_${index_i}`,
                                    type: WIDGET.TEXT,
                                },
                            ],
                        });
                        StandardUtilities.setDatastore(ROUTE.PLATFORM_LEADS, `amountLeads_${fieldName}_${index_i}`, {
                            label: `₹${addCommasToNumber(TABLE_DATA[index_i][fieldName])}`,
                        });
                    }
                    else if (fieldName === 'phoneNumber') {
                        StandardUtilities.setDatastore(ROUTE.PLATFORM_LEADS, `${fieldName}_${index_i}`, {
                            label: `${TABLE_DATA[index_i][fieldName]}`
                        });
                    }
                    else if (fieldName === 'createdOn' ||
                        fieldName === 'lastUpdatedOn') {
                        const { date, month, year } = convertISODate(TABLE_DATA[index_i][fieldName]);
                        StandardUtilities.setDatastore(ROUTE.PLATFORM_LEADS, `${fieldName}_${index_i}`, {
                            label: `${date} ${month.slice(0, 3)}, ${year}`,
                        });
                    }
                    else if (fieldName === 'customerJourney') {
                        StandardUtilities.setDatastore(ROUTE.PLATFORM_LEADS, `${fieldName}_${index_i}`, {
                            widgetItems: [
                                { id: `trackbutton_Stack_${fieldName}_${index_i}`, type: WIDGET.STACK },
                                { id: `shareLink_Stack_${fieldName}_${index_i}`, type: WIDGET.STACK },
                                { id: `viewDetail_Stack_${fieldName}_${index_i}`, type: WIDGET.STACK },
                            ]
                        });
                        console.log("Set datastore 1: ", `trackbutton_Stack_${fieldName}_${index_i}`, `shareLink_Stack_${fieldName}_${index_i}`, `viewDetail_Stack_${fieldName}_${index_i}`);
                        StandardUtilities.setDatastore(ROUTE.PLATFORM_LEADS, `viewDetail_Stack_${fieldName}_${index_i}`, {
                            action: {
                                routeId: ROUTE.PLATFORM_LEADS,
                                type: ACTION.VIEW_DETAILS,
                                payload: {
                                    user: TABLE_DATA[index_i][fieldName],
                                },
                            },
                        });
                    }
                    else {
                        StandardUtilities.setDatastore(ROUTE.PLATFORM_LEADS, `${fieldName}_${index_i}`, {
                            label: `${TABLE_DATA[index_i][fieldName]}`,
                        });
                    }
                });
        });
    }
};
